import { ChevronLeft, ChevronRight } from "lucide-react";

/** Prev / status / next pill row for the Gallery grid. */
export const Pagination = ({ page, totalPages, onChange, t }) => {
  const prev = () => onChange(Math.max(0, page - 1));
  const next = () => onChange(Math.min(totalPages - 1, page + 1));
  return (
    <div className="mt-6 flex items-center justify-between gap-3" data-testid="pagination">
      <button
        onClick={prev}
        disabled={page === 0}
        data-testid="pagination-prev"
        aria-label={t("gallery.prev")}
        className="rounded-full px-4 py-2 bg-white border border-[#E8E5DF] text-leaf-ink text-sm flex items-center gap-1.5 disabled:opacity-50 hover:bg-parchment transition"
      >
        <ChevronLeft className="w-4 h-4" strokeWidth={1.5} /> {t("gallery.prev")}
      </button>
      <span
        className="text-[11px] uppercase tracking-[0.16em] text-leaf-mist"
        data-testid="pagination-status"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        {t("gallery.pageOf", { page: page + 1, total: totalPages })}
      </span>
      <button
        onClick={next}
        disabled={page === totalPages - 1}
        data-testid="pagination-next"
        aria-label={t("gallery.next")}
        className="rounded-full px-4 py-2 bg-white border border-[#E8E5DF] text-leaf-ink text-sm flex items-center gap-1.5 disabled:opacity-50 hover:bg-parchment transition"
      >
        {t("gallery.next")} <ChevronRight className="w-4 h-4" strokeWidth={1.5} />
      </button>
    </div>
  );
};

export default Pagination;
